import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserTrainingPlanService } from '../../user-training-plan/services/user-training-plan.service';
import { Subscription, catchError, finalize, of } from 'rxjs';
import { eSignature } from '../../../shared/models/eSignature';
import { PanelList } from '../../../shared/models/panel-list';
import { CommonService } from '../../../shared/services/common.service';
import { MessageService } from 'primeng/api';
import { MySpaceConstants } from '../../my-space-constants';

@Component({
  selector: 'app-user-training-plan-review-history',
  templateUrl: './user-training-plan-review-history.component.html',
  styleUrls: ['./user-training-plan-review-history.component.scss'],
})
export class UserTrainingPlanReviewHistoryComponent
  implements OnInit, OnDestroy
{
  @Input() userPuid: any = '';
  @Output() closeSlider = new EventEmitter<boolean>()
  subscription!: Subscription;
  eSignatureInfo = {} as eSignature;
  isESignatureModalOpen = false;
  isTrainingPlanReviewHistoryModelOpen = false;
  noData: boolean = false;
  timeZoneFormat: string = '(UTC)';

  trainingPlanReviewListInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
  };

  constructor(
    private userTrainingPlanService: UserTrainingPlanService,
    private commonService: CommonService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.userTrainingReviewPlan();
  }

  // call to destroy or Unsubscribe the API call method
  ngOnDestroy(): void {
    if( this.subscription){
    this.subscription.unsubscribe();
    }
  } 
 
 onDialogHide(){
  this.closeSlider.emit(false) 
}

  // API call to fetch User Training Plan Review History Detail
  userTrainingReviewPlan() {
    // only call the API if user PUID is not null
    if (this.userPuid) {
      this.subscription = this.userTrainingPlanService
        .getTrainingPlanReviewHistoryDetailsPerUser(this.userPuid)
        .pipe(
          catchError((error) => {
            this.messageService.add({
              severity: MySpaceConstants.Severity_Err,
              summary: `${MySpaceConstants.Get_Training_Plan_Review_Failure}`,
            });
            this.isTrainingPlanReviewHistoryModelOpen = false;
            return of([]);
          }),
          finalize(() => {
          })
        )
        .subscribe((response) => {
          this.trainingPlanReviewListInput.lists = response;
          this.noData = this.commonService.IsListEmpty(
            this.trainingPlanReviewListInput.lists
          );
          this.isTrainingPlanReviewHistoryModelOpen = true;
        });
    }
  }

  // Data Setup for Esignature Modal
  openESignature(eSignatureData: any) {
    (this.eSignatureInfo.esignature = eSignatureData.esignature.eSignature),
      (this.eSignatureInfo.esignatureDateTime =
        eSignatureData.esignature.eSignatureDateTime),
      (this.eSignatureInfo.esignatureMeaning =
        eSignatureData.esignature.eSignatureMeaning);
        this.isESignatureModalOpen = true;
  }

  // Method to set Status icon Color
  getStatusClass(status: string): string {
    switch (status) {
      case 'Pending':
        return 'status-orange';
      case 'Complete':
        return 'status-green';
      default:
        return '';
    }
  }
}
